import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import ReactMarkdown from 'react-markdown'
import { AppStore } from '../store/applicationState'
// @ts-ignore
import termsPath from '../utils/terms/terms.md'

const TermsContainer = styled.div`
  padding: 0 10px 20px 10px;
  text-align: justify;
  & > h1 {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 10px;
  }
  & > h2 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 5px;
  }
  & > h3 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 5px;
  }
  & > p,
  ul,
  ol {
    margin-bottom: 10px;

    & > a {
      text-decoration: underline;
      color: rgba(2, 132, 199, 1);
    }
  }
`

export const TermsOfService = () => {
  const [userTerms, setUserTerms] = useState('')
  const { signIn, terms } = useSelector((store: AppStore) => store)

  useEffect(() => {
    if (signIn.authorized && !terms.data?.terms) {
      fetch(termsPath)
        .then((response) => response.text())
        .then((text) => {
          setUserTerms(text)
        })
    }
  }, [signIn.authorized])

  return (
    <div className='terms-container mx-auto my-10 max-w-screen-xl'>
      {userTerms && (
        <TermsContainer>
          <div className='mb-2 text-lg italic'>Last updated: Jan 16, 2026</div>
          <ReactMarkdown>{userTerms}</ReactMarkdown>
        </TermsContainer>
      )}
    </div>
  )
}
